function callForGridData() {
  if (!this.sortObj) {
    return;
  }
  if (this.ignoreGlobalSearchClear && this.globalSearchVal === "") {
    this.ignoreGlobalSearchClear = false;
    return;
  }
  const params = {
    baseUrl: this.gridUrl,
    pageIndex: this.pageIndex,
    sortOrder: this.sortObj && this.sortObj.value,
    sortKey: this.sortObj && this.sortObj.key,
    pageSize: this.pageSize,
    page: this.page,
    filters: Object.values(this.appliedFilter),
    columns: this.columns.columnFields,
    globalSearch: this.globalSearchVal,
  };
  if (this.selectedWatchlistId) {
    params["watchlist_id"] = this.selectedWatchlistId;
  }
  if (this.dataCovegTypeId !== void 0) {
    params["dataCovTypeId"] = this.dataCovegTypeId;
  }
  this.dataService.getReportGridData(params).subscribe(
    (response) => {
      this.onDataResolved(response);
      this.isLoading = false;
    },
    (err) => {
      this.isLoading = false;
      console.error(err);
    },
  );
}

export function nextPageData(pageIndex, pageSize) {
  this.isLoading = true;
  this.pageIndex = pageIndex;
  this.pageSize = pageSize;
  callForGridData.call(this);
}

export function sortChange(sortData) {
  this.isLoading = true;
  this.sortObj = sortData;
  this.sortObj.value =
    sortData.value === "ascend" || sortData.value === "asc" ? "asc" : "desc";
  callForGridData.call(this);
}

export function searchedData(val) {
  this.isLoading = true;
  this.globalSearchVal = val;
  this.pageIndex = 1;
  callForGridData.call(this);
}

export function filterData(value, columnData) {
  this.isLoading = true;
  if (value === "") {
    delete this.appliedFilter[columnData.sortKey];
    callForGridData.call(this);
    return;
  }
  const currentFilter = {
    field: columnData.sortKey,
    op: columnData.filterType === "select" ? "eq" : "cn",
    data: encodeURIComponent(value),
  };
  if (!this.appliedFilter[columnData.sortKey]) {
    this.appliedFilter[columnData.sortKey] = {};
  }
  this.appliedFilter[columnData.sortKey] = currentFilter;
  this.pageIndex = 1;
  callForGridData.call(this);
}

export function reloadGrid() {
  this.isLoading = true;
  this.gridUrl = this.initialParams["baseUrl"];
  this.pageIndex = this.initialParams["pageIndex"];
  this.sortObj.value = this.initialParams["sortOrder"];
  this.sortObj.key = this.initialParams["sortKey"];
  this.pageSize = this.initialParams["pageSize"];
  this.page = this.initialParams["page"];
  this.appliedFilter = {};
  this.globalSearchVal = "";
  if (this.dataCovTypeId !== void 0) {
    this.dataCovTypeId = 1;
  }
  this.globalSearchVal = "";
  this.customGridComp.resetAll();
  callForGridData.call(this);
}

export function getHeight() {
  const pagesWithMoreHt = ["sector", "industry", "allcompany", "allbrokers"];
  let minusHt = pagesWithMoreHt.includes(this.page) ? 316 : 496;

  if (this.page === "analyst") {
    minusHt = 416;
  }
  if (this.page === "models") {
    minusHt = 348;
  }
  if (this.page === "broker") {
    minusHt = 408;
  }
  if (this.showGridFilters) {
    minusHt = minusHt + 29;
  }
  const gHeight = `calc(100vh - ${minusHt}px)`;
  return gHeight;
}
